import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable prettier/prettier */
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import animations from 'src/styles/animations';
import errorPageBG from 'src/img/error-bg.jpg';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import { CONSTANTS, palette } from '@livable/saas-react-components';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, sections), animations.gear), animations.fadeInOut), animations.gearReverse), {}, {
  appContainer: {
    color: palette.common.black,
    fontFamily: palette.fontFamilies.source,
    display: 'flex',
    alignItems: 'stretch',
    justifyContent: 'stretch',
    // minHeight: `calc(100vh)`,
    backgroundColor: palette.shades[200]
  },
  pageContainer: {
    transition: "width ".concat(palette.transitions.short),
    margin: '0 auto',
    position: 'relative',
    paddingBottom: "".concat(CONSTANTS.PAGE_BOTTOM_PADDING, "px"),
    width: '100%',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
    [breakpointsFunc.breakpoints.down(CONSTANTS.MIN_WINDOW_WIDTH + 0.5)]: {
      paddingLeft: '56px'
    },
    '&.no-padding-on-resize': {
      paddingLeft: '0px'
    }
  },
  pageContainerOverflowHidden: {
    overflow: 'hidden'
  },
  topMargin: {
    height: "calc(100vh - ".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px', ")"),
    marginTop: "".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px')
  },
  topMarginWarning: {
    height: "calc(100vh - ".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px', " - 48px)"),
    marginTop: "calc(".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px', " + 48px)")
  },
  topMarginWarningBoth: {
    height: "calc(100vh - ".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px', " - 96px)"),
    marginTop: "calc(".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px', " + 96px)")
  },
  fullPageContainer: {
    minHeight: '100vh',
    marginLeft: '0',
    paddingLeft: '0'
  },
  tenantPortalPageContainer: {
    marginLeft: '0',
    paddingLeft: '0'
  },
  appHeader: {
    '@media print': {
      display: 'none'
    }
  },
  noBottomPadding: {
    paddingBottom: '0'
  },
  globalLoader: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '9999',
    display: 'flex',
    position: 'fixed',
    alignItems: 'center',
    backgroundColor: palette.common.white,
    justifyContent: 'center',
    '& img': {
      transform: 'scale(2)',
      animation: '$fade-in-out 10s infinite'
    }
  },
  registrationLoader: {
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '9998',
    display: 'flex',
    position: 'fixed',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.common.white
  },
  additionalInfo: {
    margin: '24px 0',
    color: palette.shades[700]
  },
  loaderWrapper: {
    margin: '24px 0 48px 0'
  },
  pendingWarningWrapper: {
    left: '0',
    right: '0',
    top: '60px',
    zIndex: '1100',
    position: 'fixed'
  },
  pendingWarning: {
    height: '48px',
    display: 'flex',
    fontSize: '13px',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette.warning.light,
    fontFamily: palette.fontFamilies.poppins,
    '& span': {
      padding: '0 16px 0 8px'
    },
    '&.error': {
      backgroundColor: palette.error.main,
      color: palette.common.white,
      '& .MuiSvgIcon-root path': {
        fill: palette.common.white
      }
    },
    '&.errorCredentials': {
      backgroundColor: palette.error.light,
      color: palette.error.main,
      '& .MuiSvgIcon-root path': {
        fill: palette.error.main
      }
    }
  },
  errorPage: {
    backgroundImage: "url(".concat(errorPageBG, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'cover',
    width: '100vw',
    height: '100vh',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  gradient: {
    background: 'linear-gradient(0deg, #F8F9FA 0%, rgba(255, 255, 255, 0) 100%)',
    width: '100vw',
    height: '100vh',
    position: 'absolute',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0'
  },
  errorContent: {
    position: 'relative',
    zIndex: '10',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  downtime: {
    width: '100px',
    height: '100px',
    position: 'relative',
    '& svg': {
      fontSize: '64px',
      position: 'absolute',
      top: '0',
      left: '0',
      animation: '$gear 1.3s infinite linear',
      '&:nth-child(1)': {
        top: '36px',
        left: '36px',
        animation: '$gear-reverse 1.3s infinite linear'
      }
    }
  }
}));
export default useStyles;